import * as React from "react";
import { IconButton } from "../../../../themeV2";
import { VolumeOffIcon, VolumeUpIcon } from "../../../../themeV2";
import { SITE_VIDEO } from "../../../../config";
import css from "./Hero.module.css";

export default function HeroVideo() {
  const videoRef = React.useRef(null);
  const [muted, setMuted] = React.useState(true);
  const [hidden, setHidden] = React.useState(true);

  React.useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    // open bug in React, cannot set video muted attribute
    videoRef.current.defaultMuted = true;
    videoRef.current.muted = true;
  }, []);

  const toggleMute = () => {
    if (!videoRef.current) {
      return;
    }

    setMuted((prev) => {
      videoRef.current.muted = !prev;
      return !prev;
    });
  };

  return (
    <div
      className={css.right}
      onMouseEnter={() => setHidden(false)}
      onMouseLeave={() => setHidden(true)}
    >
      {!hidden && (
        <IconButton
          className={css.muteButton}
          label={muted ? "Unmute video" : "Mute video"}
          onClick={toggleMute}
          size="sm"
        >
          {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
        </IconButton>
      )}

      <video
        ref={videoRef}
        autoPlay
        height="100%"
        width="100%"
        preload="auto"
        loop
        muted
        playsInline
        className={css.video}
      >
        <source src={SITE_VIDEO} type="video/mp4" />
      </video>
    </div>
  );
}
